<h1>{{ 'TO.NewOrder_Headline' | translate : 'Select customer'}}</h1>
<div>
  <div>
    <mat-form-field style="min-width: 500px;">
      <input matInput placeholder="{{'TO.NewOrder_SelectCustomer' | translate : 'Select existing customer' }}" [matAutocomplete]="customerAC" [formControl]="txtCustomer" (keyup.enter)="close()">
      <mat-autocomplete #customerAC="matAutocomplete">
        <mat-option *ngFor="let item of filteredCustomers | async" [value]="item.XalAccountNo + ' - ' + item.Name + ', ' + item.DeliveryAddress" (onSelectionChange)="selectCustomer(item)">
          <span>{{item.XalAccountNo}} - {{item.Name}},  {{item.DeliveryAddress}}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div style="text-align: center;">
    <button class="btn btn-default" [mat-dialog-close]="result" [disabled]="!result.isValid">{{ 'TO.NewOrder.cmdOk' | translate : 'OK' }}</button>
  </div>
</div>
